import React, {Fragment} from 'react'
import {t, config, Tooltip} from './base'
import utils from '@eitje/utils'
import {FieldInput} from './field_input'

const TooltipWrapper = ({tooltip, children}) => {
	if (!tooltip) return children
	return <Tooltip> {children} </Tooltip>
}

export const RightContent = props => {
	const {inputPosition} = props
	const rightElement = getRightElement(props)
	const icons = utils.alwaysArray(getIcon(props))
	const hasInput = inputPosition == 'right'

	if (!hasInput && !utils.exists(icons) && !rightElement) return null

	return (
		<config.Layout className="form-field-content-right">
			{hasInput && <FieldInput {...props} />}
			{!hasInput && icons.map(i => <FormIcon {...i} />)}
			{rightElement}
		</config.Layout>
	)
}

const FormIcon = ({Wrapper = Fragment, wrapperProps, ...rest}) => {
	return (
		<Wrapper {...wrapperProps}>
			<config.Icon size={12} {...rest} />
		</Wrapper>
	)
}

const getIcon = ({
	readOnly,
	rightElement,
	disabled,
	value,
	required,
	onChange,
	icon,
	defaultPickerValue = null,
	clearIcon = true,
	showClearIcon,
	...rest
}) => {
	if (disabled) return
	if (readOnly)
		return {
			name: 'locked',
			Wrapper: TooltipWrapper,
			wrapperProps: {title: t('form.general.tooltips.read_only')},
		}
	const buttons = []
	if (clearIcon && value && (!required || showClearIcon))
		buttons.push({
			name: 'cross',
			className: 'cross-icon',
			onClick: e => {
				e.stopPropagation()
				const defPickerValue = utils.funcOrVal(defaultPickerValue, rest)
				onChange(defPickerValue)
			},
		})

	if (!rightElement && icon) buttons.push({className: 'caret-down', name: 'caret-down'})
	return buttons
}

const getRightElement = ({rightElement, ...rest}) => {
	if (utils.exists(rest.maxLength) && !rightElement) rightElement = 'charCounter'

	if (rightElement && !_.isString(rightElement)) return React.cloneElement(rightElement, rest)

	if (rightElement == 'charCounter') return <CharCounter {...rest} />
}

const CharCounter = ({maxLength, value, ...rest}) => {
	const charsLeft = maxLength - (value?.length || 0)
	return <config.Text>{charsLeft}</config.Text>
}
